import { IMAGE_REGEX } from '../models/constants';
import Viewer360Service from './viewer360.service';

export default class ImageService {
  static changeImageDefaultFormat(
    url = '',
    rotation: string,
    width?: number
  ): string {
    let formattedImageUrl = url.replace(
      IMAGE_REGEX.ROTATION,
      `pov=BE${rotation}`
    );
    if (!Viewer360Service.is360Image(formattedImageUrl)) {
      formattedImageUrl = this.clearBBDImage(formattedImageUrl);
    } else if (width) {
      if (formattedImageUrl.match(IMAGE_REGEX.WIDTH)) {
        formattedImageUrl = formattedImageUrl.replace(
          IMAGE_REGEX.WIDTH,
          `width=${width}`
        );
      } else {
        formattedImageUrl += `&width=${width}`;
      }
    }
    return formattedImageUrl;
  }

  static clearBBDImage(image: string): string {
    return image.split('?')[0];
  }
}
